// Funciones puras de la pantalla "Delivery a domicilio - Pedidos".
// Separadas del componente para poder testearlas sin montarlo.

export const ESTADOS_TEROS = {
  sincronizado: { etiqueta: "En Teros", color: "success" },
  pendiente: { etiqueta: "Pendiente", color: "warning" },
  revision: { etiqueta: "Revisar", color: "error" },
};

export const estadoTeros = (estado) =>
  ESTADOS_TEROS[estado] ?? { etiqueta: "-", color: "default" };

// nropedido vale 0 mientras el pedido no llegó a Teros: ahí se identifica
// por la referencia web, la misma que figura en el WhatsApp.
export const numeroVisible = (pedido) => {
  if (pedido?.nropedido > 0) return String(pedido.nropedido);
  return pedido?.referencia || "-";
};

export const nombreCliente = (pedido) => {
  const nombre = `${pedido?.cliente?.nombre || ""} ${pedido?.cliente?.apellido || ""}`.trim();
  return nombre || "-";
};

const fechaInput = (fecha) => {
  const anio = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, "0");
  const dia = String(fecha.getDate()).padStart(2, "0");
  return `${anio}-${mes}-${dia}`;
};

export const crearFiltrosPorDefecto = (hoy = new Date()) => ({
  numero: "",
  cedula: "",
  telefono: "",
  estado: "",
  fecha_desde: fechaInput(new Date(hoy.getFullYear(), hoy.getMonth(), 1)),
  fecha_hasta: fechaInput(new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0)),
});

export const limpiarFiltros = (filtros) =>
  Object.entries(filtros).reduce((acc, [clave, valor]) => {
    const limpio = typeof valor === "string" ? valor.trim() : valor;
    if (limpio) acc[clave] = limpio;
    return acc;
  }, {});

export const ETIQUETAS_FILTROS = {
  numero: "Nro. pedido o referencia",
  cedula: "Documento",
  telefono: "Teléfono",
  estado: "Estado",
  fecha_desde: "Fecha desde",
  fecha_hasta: "Fecha hasta",
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return iso;
  return fecha.toLocaleString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatCurrency = (valor) => {
  if (valor == null || valor === "") return "-";
  const numero = Number(valor);
  if (Number.isNaN(numero)) return valor;
  return new Intl.NumberFormat("es-PY").format(numero);
};

export const formatQuantity = (valor) => {
  if (valor == null || valor === "") return "-";
  return new Intl.NumberFormat("es-PY", {
    minimumFractionDigits: Number.isInteger(valor) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(valor);
};
